import React from 'react';

const SignOut: React.FunctionComponent<any> = props => {
    console.warn('SignOut');

    return <div>SignOut</div>;
};

export default SignOut;
